import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const PROMISES = ['Sepa exactamente cuándo iniciar una TRT… y cuándo no hacerlo.', 'Interprete cualquier perfil hormonal sin dudar.', 'Responda con seguridad sobre fertilidad, próstata y riesgo cardiovascular.', 'Sepa qué monitorear, cuándo ajustar la dosis y cuándo suspender.'];
export function Hero() {
  return <header className="w-full bg-cream-50 pb-10 pt-6 sm:pb-14 sm:pt-8" data-id="element-105" data-mp="xae6qyecaek8">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-106" data-mp="x8b8xs6y3h4y">
        <div className="flex flex-col items-center" data-id="element-107" data-mp="sai3j1dgur5q">
          <div className="flex items-center gap-2 rounded-full border border-navy-900/10 bg-white px-3.5 py-1.5 shadow-sm" data-id="element-108" data-mp="sd4bh249r8oh">
            <span className="font-display text-base font-bold text-navy-900" data-id="element-109" data-mp="3d1aafpn8alfx">Dra.</span>
            <span className="font-display text-base font-bold text-gold-600" data-id="element-110" data-mp="382ffjpbzl6fg">Karito</span>
            <span className="h-3.5 w-px bg-navy-900/15" aria-hidden="true" data-id="element-111" data-mp="384s5aonzkl32" />
            <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-navy-800/60" data-id="element-112" data-mp="3j9agpbwlmo4m">
              Decisión Clínica
            </span>
          </div>

          <h1 className="mt-6 text-center font-display text-[30px] font-bold leading-[1.08] text-navy-900 sm:text-5xl" data-id="element-113" data-mp="399b9bibx13tc">
            Prescriba Terapia de Reemplazo con Testosterona con seguridad{' '}
            <span className="text-gold-600" data-id="element-114" data-mp="30gzwx0dmzgwd">desde su próxima consulta</span>, sin depender de cientos de páginas de guías clínicas.
          </h1>

          <p className="mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-115" data-mp="35au9zkyqkxmh">
            El Sistema Maestro de TRT  <strong className="font-semibold text-navy-900" data-id="element-116" data-mp="2viewazuh2v7e"></strong>{' '}
            reúne protocolos clínicos, algoritmos de decisión y rutas terapéuticas para ayudarle a diagnosticar, indicar, ajustar y monitorizar la TRT con rapidez, seguridad y respaldo científico.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="mt-7 w-full" data-id="element-117" data-mp="s1rqcip57wrn">
            <img src="https://cdn.magicpatterns.com/uploads/a65RQWDrFqQ21wHBAu6km1/reparaciones_mockup_sin_fondo-5.png" alt="Sistema Maestro de TRT: 6 tomos clínicos, algoritmos y protocolos en computadora, tablet y celular" className="mx-auto w-full max-w-[520px]" loading="eager" data-id="element-118" data-mp="id050tel8app" />
          </motion.div>

          <ul className="mx-auto mt-2 w-full max-w-md space-y-2.5 text-left" data-id="element-119" data-mp="162capjapi0n9">
            {PROMISES.map(promise => <li key={promise} className="flex items-start gap-2.5" data-id="element-120" data-mp="11154hoo7p9ip">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy-900" data-id="element-121" data-mp="x02zssbj059c">
                  <CheckIcon className="h-3 w-3 text-gold-400" aria-hidden="true" data-id="element-122" data-mp="3ltqgvowuphzb" />
                </span>
                <span className="text-[14px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-123" data-mp="3hpsft8nytx3m">
                  {promise}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 w-full max-w-md rounded-3xl border border-gold-500/25 bg-white p-4 shadow-[0_18px_40px_-24px_rgba(11,32,56,0.45)] sm:p-5" data-id="element-124" data-mp="21bplrecubp0o">
            <p className="text-center text-[12px] font-bold uppercase tracking-[0.12em] text-navy-800/60" data-id="element-125" data-mp="2b0pq7da43cm9">
              Hoy, en lugar de USD 546
            </p>
            <p className="mt-1 text-center font-display text-4xl font-bold text-navy-900 sm:text-5xl" data-id="element-126" data-mp="2fzj1r05u8tjs">
              USD 12.99
            </p>
            <p className="mt-1 text-center text-[12px] font-medium text-navy-800/65" data-id="element-127" data-mp="2p0qoqm2wm7yk">
              Pago único · Cambio de moneda automático en su país
            </p>
            <div className="mt-4" id="cta-hero" data-id="element-128" data-mp="2txhddxsrybvl">
              <CtaButton label="Quiero el Sistema Maestro de TRT" subLabel="Descarga inmediata · Sin suscripción · Acceso de por vida · Garantía 7 días" data-id="element-129" data-mp="un9a5okh8lfo" />
            </div>
            <div className="mt-4 flex justify-center" data-id="element-130" data-mp="4be13s18avuf">
              <Countdown data-id="element-131" data-mp="49t47vrfz0te" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}